<template>
  <van-uploader
    v-model="fileList"
    :max-count="maxCount"
    :after-read="upLoadImage"
    @delete="deleteImg"
    image-fit="contain"
    :preview-full-image="false"
    :style="{ width: width, height: height, minWidth: '80px' }"
  >
  </van-uploader>
</template>

<script>
import { getToken } from '@/api/liveShop';
import BMF from 'browser-md5-file';
import * as qiniu from 'qiniu-js';
import { Toast } from 'vant';
const bmf = new BMF();

export default {
  props: {
    width: {
      type: String,
      default: '80px',
    },
    height: {
      type: String,
      default: '80px',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    maxCount: {
      type: String,
      default: '1',
    },
    uploadShow: {
      default: true,
    },
  },
  data() {
    return {
      fileList: [],
      isUploading: false, // 是否正在上传图片
    };
  },
  watch: {
    uploadShow: function(value) {
      if (!value) {
        console.log('uploadShow', value);
        this.fileList = [];
      }
    },
    // 反选
    imageUrl: {
      handler(value) {
        // this.fileList.length === 0 判断是，如果fileList 有值的话，再赋值 imageurl  会导致重新加载一遍图片
        console.log(value);
        if (value && this.fileList.length === 0) {
          if (value instanceof Array) {
            value.map(v => {
              this.fileList.push({ url: v });
            });
          } else if (value.keep) {
            value.keep = false;
            this.fileList = [{ url: value.imageUrl }];
          } else {
            this.fileList = [{ url: value }];
          }
        } else if (!value) {
          this.fileList = [];
        } else if (value.keep) {
          value.keep = false;
          this.fileList = [];
          this.fileList.push({ url: value.imageUrl });
        }
      },
      immediate: true,
    },
  },
  methods: {
    async upLoadImage(file, detail) {
      // 处理图片大小
      try {
        this.isUploading = true;
        file.status = 'uploading';
        file.message = '压缩中...';
        // 1、压缩图片
        await this.handleImageSize(file);
        file.message = '上传中...';

        // 2、获取图片宽高 破组件居然不直接返回
        const imageSize = await this.getImageSize(file.content);
        //  3 、 获取七牛token
        let qiniuToken = '';
        if (this.$store.state.app.qiniuToken) {
          qiniuToken = this.$store.state.app.qiniuToken;
        } else {
          const tokenRes = await getToken();
          console.log(tokenRes);
          qiniuToken = tokenRes.data.token;
          this.$store.commit('setQiniuToken', qiniuToken);
        }
        //  4、 获取上传图片名称的md5 值
        const MD5Object = await this.getMD5Object(file.file);
        //  5、上传七牛
        const upResult = await this.upToQiniu(MD5Object, qiniuToken, file);
        const domain = 'https://img.zai-art.com/';
        // 6、拼接图片地址
        const imageUrl = domain + upResult.key;
        file.status = 'done';
        const imageResult = Object.assign(imageSize, { imageUrl });
        this.$emit('success', imageResult);
      } catch (error) {
        if (error) {
          this.isUploading = false;
          Toast.fail(error);
          file.status = 'failed';
          file.message = '上传失败';
          this.fileList = [];
        }
      }
    },

    getMD5Object(imgFile) {
      return new Promise((resolve, reject) => {
        bmf.md5(
          imgFile,
          (err, md5) => {
            if (md5) {
              const keyname = 'zaiart/saas/image/md/';
              const key = keyname + md5 + imgFile.name.substr(imgFile.name.lastIndexOf('.'));
              resolve({ imgFile, key });
            } else {
              reject(err);
            }
          },
          progress => {},
        );
      });
    },
    // 上传到七牛
    upToQiniu(MD5Object, uptoken, file) {
      return new Promise((resolve, reject) => {
        // var key = file.name // 上传后文件资源名以设置的 key 为主，如果 key 为 null 或者 undefined，则文件资源名会以 hash 值作为资源名。
        const config = {
          useCdnDomain: false, // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
          region: null, // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
        };
        const putExtra = {
          fname: '', // 文件原文件名
          params: {}, // 用来放置自定义变量
          mimeType: ['image/png', 'image/jpeg', 'image/gif', 'image/jpg'], // 用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
        };
        const observable = qiniu.upload(
          MD5Object.imgFile,
          MD5Object.key,
          uptoken,
          putExtra,
          config,
        );

        observable.subscribe({
          next: result => {
            // 展示进度
            // this.fileData[i].percent = parseInt(result.total.percent)
          },
          error: errResult => {
            //token失效，重置
            if (errResult.error == 'expired token') {
              this.$store.commit('setQiniuToken', '');
              this.upLoadImage(file);
            }
            // 失败报错信
            reject(errResult);
          },
          complete: result => {
            resolve(result);
          },
        });
      });
    },

    getImageSize(imageContent) {
      return new Promise(resolve => {
        let image = new Image();
        image.onload = () => {
          resolve({ imageWidth: image.width, imageHeight: image.height });
        };
        image.onerror = () => {
          resolve({ imageWidth: 0, imageHeight: 0 });
        };
        image.src = imageContent;
      });
    },

    deleteImg(file, detail) {
      this.$emit('delete', detail);
    },

    // 处理图片大小 看是否需要压缩
    handleImageSize(file) {
      return new Promise((resolve, reject) => {
        if (file.file.size < 1 * 1024 * 1024) {
          // 小于1M 直接成功
          resolve();
          return;
        }
        const content = file.content; //图片的src，base64格式
        const img = new Image();
        img.src = content;
        img.onload = () => {
          //图片加载完毕
          this.compressImageEvent(img, dataURL => {
            file.content = dataURL; // 赋值压缩后的图片
            const blob = this.dataURItoBlob(dataURL);
            const newFile = new File([blob], file.file.name, { type: file.file.type }); // 转换成 file
            file.file = newFile;
            resolve();
          });
        };
        img.onerror = () => {
          reject();
        };
      });
    },
    // 压缩图片
    compressImageEvent(img, callback) {
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      let dataURL = canvas.toDataURL('image/jpeg', 0.8);
      callback(dataURL); //调用回调函数
    },
    // 将 base64 图片，转blob
    dataURItoBlob(dataurl) {
      //dataurl是base64格式
      let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
  },
};
</script>

<style lang="less" scoped>
// 复写 van uploader 的size
@max-upload-width: 345px;
/deep/ .van-uploader__preview-image {
  width: 100%;
  height: 100%;
}
/deep/ .van-uploader__upload {
  width: 100%;
  height: 100%;
  margin: 0;
  max-width: @max-upload-width;
}
/deep/ .van-uploader__wrapper {
  width: 100%;
  height: 100%;
  max-width: @max-upload-width;
}
/deep/ .van-uploader__preview {
  width: 100%;
  height: 100%;
  margin: 0;
  max-width: @max-upload-width;
}

/deep/ .van-uploader__upload-icon {
  font-size: 24px;
}
/deep/ .van-uploader__wrapper {
  flex-wrap: nowrap;
}
</style>
